module.exports = __webpack_public_path__ + "1f43b01742b99ec72280fbdf37730452.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/1/Assets/2to3.png
// module id = 1349
// module chunks = 0